import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-travel-wage-set',
  templateUrl: './travel-wage-set.component.html',
  styleUrls: ['./travel-wage-set.component.css']
})
export class TravelWageSetComponent implements OnInit {
    travelWageSetKeyno;

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.travelWageSetKeyno = this.stateService.getStateParams()['travelwageset_keyno'];
    }

    private async loadEdit() {
        if (!!this.travelWageSetKeyno) {
            this.edit = (await this.datatask.Post(1501, { travelwageset_keyno: this.travelWageSetKeyno }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1502, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    travelwageset_keyno: number;
    travelwageset_name: string;
    valid_fom_dt: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('travelWageSet', {
//        templateUrl: 'views/components/views/travelWageSet/travelWageSet.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'travelWageSetService', function ($stateParams, stateService, translateService, modalService, travelWageSetService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let travelWageSetKeyno = $stateParams.travelwageset_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                edit: {},
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            translateService.translateBatch(translations).then(function (data) {
//                angular.forEach(translations, function (_, key) {
//                    if (angular.isDefined(data[key])) {
//                        translations[key] = data[key];
//                    }
//                });
//            });

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE CALLS

//            let loadEdit = function () {
//                travelWageSetService.getEdit({ travelwageset_keyno: travelWageSetKeyno }).then(function (info) {
//                    angular.copy(info[0], vm.model.edit);
//                });
//            };

//            // #endregion LOAD PROCEDURE CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                travelWageSetService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadEdit();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
